var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixHeadlessV1OAuthApp from '@wix/ambassador-headless-v1-o-auth-app/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
/** OAuth application type. */
export var OAuthAppType;
(function (OAuthAppType) {
    /** OAuth app type is not specified. */
    OAuthAppType["OAUTH_APP_TYPE_UNSPECIFIED"] = "OAUTH_APP_TYPE_UNSPECIFIED";
    /** OAuth app type is a web application. */
    OAuthAppType["WEB_APP"] = "WEB_APP";
    /** OAuth app type is a mobile application. */
    OAuthAppType["MOBILE"] = "MOBILE";
    /** OAuth app type is some other type of application. */
    OAuthAppType["OTHER"] = "OTHER";
})(OAuthAppType || (OAuthAppType = {}));
/** OAuth technology used by the oauth application. */
export var OAuthTechnologies;
(function (OAuthTechnologies) {
    /** The OAuth technology is not specified. */
    OAuthTechnologies["OAUTH_TECHNOLOGY_UNSPECIFIED"] = "OAUTH_TECHNOLOGY_UNSPECIFIED";
    /** OAuth technology using JavaScript. */
    OAuthTechnologies["JAVASCRIPT"] = "JAVASCRIPT";
    /** OAuth technology using Angular. */
    OAuthTechnologies["ANGULAR"] = "ANGULAR";
    /** OAuth technology using Vue.js. */
    OAuthTechnologies["VUE"] = "VUE";
    /** OAuth technology using React. */
    OAuthTechnologies["REACT"] = "REACT";
    /** OAuth technology using React Native. */
    OAuthTechnologies["REACT_NATIVE"] = "REACT_NATIVE";
    /** OAuth technology using iOS. */
    OAuthTechnologies["IOS"] = "IOS";
    /** OAuth technology using Android. */
    OAuthTechnologies["ANDROID"] = "ANDROID";
    /** OAuth technology using some other kind of technology. */
    OAuthTechnologies["OTHER_TECHNOLOGY"] = "OTHER_TECHNOLOGY";
})(OAuthTechnologies || (OAuthTechnologies = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["PENDING"] = "PENDING";
    State["DEMO"] = "DEMO";
})(State || (State = {}));
export var SiteCreatedContext;
(function (SiteCreatedContext) {
    /** A valid option, we don't expose all reasons why site might be created. */
    SiteCreatedContext["OTHER"] = "OTHER";
    /** A meta site was created from template. */
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    /** A meta site was created by copying of the transfferred meta site. */
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    /** A copy of existing meta site. */
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    /** deprecated A meta site was created for Flash editor. */
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext || (SiteCreatedContext = {}));
export var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
    Namespace["WIX"] = "WIX";
    /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ALBUMS"] = "ALBUMS";
    /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["HOTELS"] = "HOTELS";
    /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["CLUBS"] = "CLUBS";
    /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_SITE"] = "DEV_SITE";
    /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["LOGOS"] = "LOGOS";
    /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    /**
     * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
     *
     * Meta site with this namespace will *not* be shown in a user's site list by default.
     */
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    /**
     * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
     * Will be accessible from Site List and will not have a website app.
     * Once the user attaches a site, the site will become a regular wixsite.
     */
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    /** It is to be used in the Business First efforts. */
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    /** Bookings business flow with no site. */
    Namespace["ANYWHERE"] = "ANYWHERE";
    /** Namespace for Headless Backoffice with no editor */
    Namespace["HEADLESS"] = "HEADLESS";
    /**
     * Namespace for master site that will exist in parent account that will be referenced by subaccounts
     * The site will be used for account level CSM feature for enterprise
     */
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
    /** Rise.ai Siteless account management for Gift Cards and Store Credit. */
    Namespace["RISE"] = "RISE";
    /**
     * As part of the branded app new funnel, users now can create a meta site that will be branded app first.
     * There's a blank site behind the scene but it's blank).
     * The Mobile company will be the owner of this namespace.
     */
    Namespace["BRANDED_FIRST"] = "BRANDED_FIRST";
})(Namespace || (Namespace = {}));
export var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
})(DeleteStatus || (DeleteStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _createOAuthAppRequest = {};
const _createOAuthAppResponse = {};
const _deleteOAuthAppRequest = {};
const _deleteOAuthAppResponse = {};
const _generateOAuthAppSecretRequest = {};
const _generateOAuthAppSecretResponse = {};
const _getOAuthAppRequest = {};
const _getOAuthAppResponse = {};
const _queryOAuthAppsRequest = {};
const _queryOAuthAppsResponse = {};
const _updateOAuthAppRequest = {};
const _updateOAuthAppResponse = {};
/**
 * Creates a new OAuth app for a Wix Headless client.
 *
 *
 * An OAuth app authorizes an external client app or site, on any platform, to authenticate with a Wix site or project and manage its data.
 *
 * > **Note:** The OAuth app secret is returned only when creating the OAuth app, and can't be retrieved later. Store the secret in a secure location.
 * @param oAuthApp - OAuth app to create.
 * @public
 * @documentationMaturity preview
 * @requiredField oAuthApp
 * @requiredField oAuthApp.name
 * @adminMethod
 * @returns Created OAuth app info.
 */
export function createOAuthApp(oAuthApp) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { oAuthApp: '$[0]' };
        const responseTransformation = '$.oAuthApp';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createOAuthAppRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['oAuthApp']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createOAuthAppResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['oAuthApp']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([oAuthApp]);
        const reqOpts = ambassadorWixHeadlessV1OAuthApp.createOAuthApp(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'oAuthApp',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves an OAuth app by ID.
 * @param oAuthAppId - ID of the OAuth app to retrieve.
 * @public
 * @documentationMaturity preview
 * @requiredField oAuthAppId
 * @adminMethod
 * @returns Retrieved OAuth app info.
 */
export function getOAuthApp(oAuthAppId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { oAuthAppId: '$[0]' };
        const responseTransformation = '$.oAuthApp';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getOAuthAppRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getOAuthAppResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['oAuthApp']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([oAuthAppId]);
        const reqOpts = ambassadorWixHeadlessV1OAuthApp.getOAuthApp(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'oAuthAppId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates an OAuth app.
 *
 *
 * Only fields provided in `mask` are updated.
 *
 * You can update the following fields:
 * + `name`
 * + `description`
 * + `allowedDomain`
 * + `loginUrl`
 * + `logoutUrl`
 * + `technology`
 * @param _id - ID of the OAuth app.
 * @param mask - Explicit list of fields to update. Only fields listed are updated.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField mask
 * @requiredField oAuthApp
 * @adminMethod
 * @returns Updated OAuth app info.
 */
export function updateOAuthApp(_id, oAuthApp, mask) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            oAuthApp: { '*': '$[1]', id: '$[0]' },
            mask: '$[2]',
        };
        const responseTransformation = '$.oAuthApp';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateOAuthAppRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['oAuthApp']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateOAuthAppResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['oAuthApp']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, oAuthApp, mask]);
        const reqOpts = ambassadorWixHeadlessV1OAuthApp.updateOAuthApp(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'oAuthApp',
                'mask',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes an OAuth app by ID.
 *
 *
 * > **Note:** After you delete an OAuth app, an external client can no longer make API calls by authenticating with its client ID.
 * @param oAuthAppId - ID of the OAuth app to delete.
 * @internal
 * @documentationMaturity preview
 * @requiredField oAuthAppId
 * @adminMethod
 */
export function deleteOAuthApp(oAuthAppId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { oAuthAppId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteOAuthAppRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteOAuthAppResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([oAuthAppId]);
        const reqOpts = ambassadorWixHeadlessV1OAuthApp.deleteOAuthApp(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'oAuthAppId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of OAuth apps, given the provided paging, filtering, and sorting.
 *
 *
 * Query OAuth Apps runs with these defaults, which you can override:
 * + Results are sorted by `id` in descending order.
 * + `paging.offset` is `0`.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function queryOAuthApps() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.oAuthApps',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryOAuthAppsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryOAuthAppsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#oAuthApps']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixHeadlessV1OAuthApp.queryOAuthApps(payload);
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'OFFSET',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Generates a secret for an existing OAuth app.
 *
 *
 * > **Note:** You can only generate a secret once for each OAuth app, and the secret can't be retrieved later. Store the secret securely.
 * @param oAuthAppId - ID of the OAuth app to generate a secret for.
 * @internal
 * @documentationMaturity preview
 * @requiredField oAuthAppId
 * @adminMethod
 */
export function generateOAuthAppSecret(oAuthAppId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { oAuthAppId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateOAuthAppSecretRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateOAuthAppSecretResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([oAuthAppId]);
        const reqOpts = ambassadorWixHeadlessV1OAuthApp.generateOAuthAppSecret(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'oAuthAppId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=headless-v1-o-auth-app.universal.js.map